import { IconButton, Icons } from '@cast/design-system';

import { useWorkloadQuickViewChartsDialog } from '../_hooks/useWorkloadQuickViewChartsDialog';

type Props = {
  workloadId: string;
};

export const ActionsMenu = ({ workloadId }: Props) => {
  const { openDialog } = useWorkloadQuickViewChartsDialog();

  return (
    <IconButton
      testId="workload-metrics-chart-button"
      variant="ghost"
      size="sm"
      sx={{
        paddingX: '13px',
        height: '40px !important',
        width: '40px !important',
      }}
      onClick={() => openDialog({ workloadId })}
    >
      <Icons.ChartLine />
    </IconButton>
  );
};
